import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { RecipientRequestDetailsType } from '@/types/vendorVaultTypes';

export const getRecipientRequestApi = (
  id: string,
  reveal = false
): Promise<ApiResponseType<RecipientRequestDetailsType>> =>
  authApiService.GET(`/vendor-vault/requests/${id}/`, reveal ? { reveal: '1' } : undefined);
